import React from 'react';
import { Avatar as AvatarFit } from '@fiverr-private/fit';
import { FederatedSeller, useSellerData, ProAvatar } from '@fiverr-private/seller_pages_toolbox';
import { VideoAvatar } from '../VideoAvatar/VideoAvatar';

export const Avatar = () => {
    const { profileImageUrl, username, isPro, introVideo } = useSellerData(selectSellerSlice);
    const introVideoUrl = introVideo?.url;

    if (introVideoUrl) {
        return <VideoAvatar />;
    }
    if (isPro) {
        return <ProAvatar avatarSize="2xl" />;
    }
    return <AvatarFit size={120} username={username} src={profileImageUrl} />;
};

function selectSellerSlice(seller: FederatedSeller) {
    return {
        username: seller.user.name,
        profileImageUrl: seller.user.profileImageUrl,
        introVideo: seller.introVideo,
        isPro: seller.isPro,
    };
}
